import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { DnLoaderModule } from '../dn-loader/dn-loader.module';
import { DnCustomBtnComponent } from './dn-custom-btn.component';

@NgModule({
  declarations: [DnCustomBtnComponent],
  imports: [CommonModule, MatButtonModule, DnLoaderModule],
  exports: [DnCustomBtnComponent],
})
export class DnCustomBtnModule {}
